import React from 'react';

/**
 * The navigation icons, taken from the inline SVG that used to live in App.js.
 * admin-app has no icon library and is not getting one for this.
 *
 * svgProps intentionally omits strokeLinecap/strokeLinejoin: the original
 * hand-written <svg> tags in App.js never set them either (default butt caps,
 * miter joins), and this task must not shift anything on screen.
 */

const svgProps = {
  // Every one of these sits beside its own text label, so to a screen reader
  // the icon is decoration that would otherwise be announced twice.
  'aria-hidden': 'true',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: '2',
};

export const DashboardIcon = ({ className }) => (
  <svg className={className} {...svgProps}>
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="14" y="14" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
  </svg>
);

export const BranchesIcon = ({ className }) => (
  <svg className={className} {...svgProps}>
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

export const UsersIcon = ({ className }) => (
  <svg className={className} {...svgProps}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

export const ReportsIcon = ({ className }) => (
  <svg className={className} {...svgProps}>
    <path d="M9 17v-6" />
    <path d="M13 17v-3" />
    <path d="M17 17v-8" />
    <rect x="3" y="3" width="18" height="18" rx="2" />
  </svg>
);

export const ProductsIcon = ({ className }) => (
  <svg className={className} {...svgProps}>
    <line x1="16.5" y1="9.4" x2="7.5" y2="4.21" />
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
);

export const MedicationsIcon = ({ className }) => (
  <svg className={className} {...svgProps}>
    <path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z" />
    <path d="m8.5 8.5 7 7" />
  </svg>
);

export const AdminsIcon = ({ className }) => (
  <svg className={className} {...svgProps}>
    <path d="M12 2L2 7l10 5 10-5-10-5z" />
    <path d="M2 17l10 5 10-5" />
    <path d="M2 12l10 5 10-5" />
  </svg>
);

export const LogoutIcon = ({ className }) => (
  <svg className={className} {...svgProps}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

export const MenuIcon = ({ className }) => (
  <svg className={className} {...svgProps}>
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

export const MoreIcon = ({ className }) => (
  <svg className={className} {...svgProps}>
    <line x1="4" y1="7" x2="20" y2="7" />
    <line x1="4" y1="12" x2="20" y2="12" />
    <line x1="4" y1="17" x2="14" y2="17" />
  </svg>
);

export const CloseIcon = ({ className }) => (
  <svg className={className} {...svgProps}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
